<template>
  <div class="user-coupons-wrap">
    <div class="exchange-box">
      <h3 class="coupont-flag" v-t="'center.coupon.have'"></h3>
      <v-input v-model="code" class="iview-input" :placeholder="$t('tip.input.coupon')"></v-input>
      <Button class="cd-btn" @click.native="convert">{{ $t('center.coupon.button[0]') }}</Button>
    </div>
    <div class="coupons-box">
     <!--  <div class="coupont-types__tab">
        <a @click.stop="type='unuse'" :class="{actived:type=='unuse'}" href="javascript:;">未使用</a>
        <a @click.stop="type='used'" :class="{actived:type=='used'}" href="javascript:;">已使用</a>
        <a @click.stop="type='history'" :class="{actived:type=='history'}" href="javascript:;">已过期</a>
      </div> -->
      <Spin v-if="isLoading" size="large" fix></Spin>
      <ul v-if="coupons.length > 0" class="coupons__ul">
        <li v-for="(item, index) in coupons" :key="index" class="coupon-item">
          <!-- 满减券、现金券、赠送卡 -->
          <!-- <div v-if="item.type !== 2" class="coupon-price">
            {{ '￥' + item.offsetMoney }}
          </div> -->
          <!-- 金额减免 -->
          <span  class="coupon-price" v-if="item.type == 3 || item.type == 4 || item.type == 6">
            {{ '￥' + item.offsetMoney }}
          </span>
          <!-- 餐品优惠券 -->
          <span v-else-if="item.type == 1 |item.type == 2" class="food-coupon"></span>
          <!-- 餐品折扣券 -->
          <span class="discount-coupon" v-else-if="item.type == 5">
            {{ item.discount }}%
            <br />
            OFF
          </span>
          <!-- 赠品券 -->
          <!-- <span v-else class="coupon-goods" @click="showProducts(item.productNames)">
            {{ $t('center.coupon.view') }}
            <a @click="showProducts(item.productNames)" class="check-foods__btn" href="javascript:;">
              {{ $t('center.coupon.view') }}
            </a>
          </span> -->

          <div class="coupon-txt">
            <!-- <p v-if="item.storeType === 0" style="padding-right: 165px;">
              <span>适用范围</span>
              <span v-if="item.storeList.length > 0"
                v-for="(store, i) in item.storeList" :key="i">{{(i>0?', ':'')+store.storeName}}</span>
              <span v-if="!item.storeList.length && item.useIds.length > 0"
                v-for="(use, i) in item.useIds" :key="i">{{(i>0?', ':'')+use.name}}</span>
            </p>

            <p v-if="item.storeType === 1" style="padding-right: 165px;">
              <span>适用范围</span>
              <span v-if="item.brandList.length > 0"
                v-for="(store, i) in item.brandList" :key="i">

                {{(i>0?', ':'')+store.brandName}}
                <span v-if="item.applyCity === 0 || (item.cityIds[0] === 0&&item.provinceIds[0]) === 0 || item.provinceIds[0] === 0">（'full_brand')</span>
              </span>
            </p> -->

            <!-- <p v-if="item.storeType === 1&&item.applyCity===1&&item.provinceIds[0] !== 0" style="padding-right: 165px;" :title="arwen-海绵宝宝">
              <span>适用省份</span>
              <span
                v-for="(name, i) in item.provinceNames" :key="i">{{(i>0?', ':'')+name}}</span>
            </p>

            <p v-if="item.storeType === 1&&item.applyCity===1&&item.cityIds[0] !== 0" style="padding-right: 165px;" >
              <span>适用城市</span>
              <span
                v-for="(name, i) in item.cityNames" :key="i">{{(i>0?', ':'')+name}}</span>
            </p>
 -->
            <!-- <p v-if="item.storeType === 1 && item.exceptionStoreList" style="padding-right: 165px;">
                <span>不适用门店</span>
                <span v-if="item.exceptionStoreList.length !== 0"
                  v-for="(store, i) in item.exceptionStoreList" :key="i">{{(i>0?', ':'') + store.storeName}}
                </span>
                <span v-if="item.exceptionStoreList.length === 0">
                  无
                </span>
            </p>
 -->
            <!-- <p style="padding-right: 165px;">
              <span>适用时间</span>
              <span v-for="(date, i) in item.useDateTime.dates" :key="i + 'datas'">{{date.name + (i>0?' ':'')}}</span>
              <span>, </span>
              <span v-for="(time, i) in item.useDateTime.times" :key="i + 'times'">{{(i>0?' ':'') + time.startTime + '~' + time.endTime}}</span>
            </p> -->
            <p class="coupon-item-name">
              <span>{{ item.name }}</span>
            </p>
            <p>
              <!-- 有效期: -->
              <span>&nbsp;&nbsp;&nbsp;{{ $t('center.coupon.valid') }}</span>
              &nbsp;
              {{ !item.isLongTime ? item.endTime : $t('center.coupon.long') }}
            </p>
            <v-poptip class="iview-poptip" placement="bottom-end" width="337" word-wrap :offset="10">
              <!-- 使用细则 -->
              <p class="coupon-item-detailed">
                {{ $t('center.coupon.rule') }}
              </p>
              <div class="coupon-item-detailed-content" slot="content">
                <!-- 使用说明 -->
                <p>{{ $t('center.coupon.instructions') }}</p>
                <p class="content-explain">{{ item.explain || '' }}</p>
                <p>
                  <!-- 适用条件: -->
                  <span>{{ $t('center.coupon.condition') }}</span>
                  &nbsp;
                  <!-- 购买指定餐品 -->
                  <span v-if="item.needBuyProductIds && item.needBuyProductIds.length > 0">{{ $t('center.coupon.special') }}</span>
                  <!-- 餐品金额满{{'￥'+ item.minMoney}} 可使用 -->
                  <span v-else>{{ $t('center.coupon.amount', { money: '￥'+ item.minMoney }) }}</span>
                </p>
              </div>
            </v-poptip>
          </div>
        </li>

        <!-- <li class="coupon-item">
          <div class="coupon-goods">
            <p>赠送指定餐品</p>
            <a class="check-foods__btn" href="javascript:;">查看餐品</a>
          </div>
          <div class="coupon-txt">
            <p>适用范围: XXXXXXXX</p>
            <p>适用时间: 星期一至星期日</p>
            <p>餐品金额满￥4减3</p>
          </div>
          <div class="coupon-valid">
            <p>有效期</p>
            <p class="time">2018-01-27</p>
          </div>
        </li> -->
      </ul>
      <!-- 您还没有优惠券！ -->
      <div v-else class="coupons-error-tips">{{ $t('center.coupon.not') }}</div>
    </div>
  </div>
</template>
<script>
import {
  Input, Poptip,
} from 'iview';

export default {
  name: 'coupons',
  components: {
    VInput: Input,
    VPoptip: Poptip,
  },
  data() {
    return {
      isLoading: false,
      code: '',
      type: '', // unuse, used, history
      coupons: [],
    };
  },
  methods: {
    convert() {
      // 兑换优惠券
      if (this.code.replace(/\s/, '') === '') {
        this.$Modal.info({
          name: this.$t('tip.hint'),
          content: `${this.$t('tip.input.couponCode')}!`,
        });
        // Modal.alert({ content: 'inputRightKey' });
        return false;
      }
      this.isLoading = true;
      this.$service.preferential.coupon.convert({ content: { code: this.code } })
        .then((result) => {
          this.$Modal.info({
            name: this.$t('tip.hint'),
            content: result.msg,
            onOk() {
              this.getCoupons();
            },
          });
        })
        .catch((err) => {
          if (err.msg) {
            this.$Modal.info({
              name: this.$t('tip.hint'),
              content: err.msg,
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
      return true;
    },
    getCoupons() {
      // 获取优惠券列表
      this.coupons.splice(0);
      this.isLoading = true;
      // let action = 'getHistoryCoupons';
      // if (type === 'unuse') {
      //   action = 'getValidateCoupons';
      // }
      this.$service.preferential.third.list({ content: { pageNow: 1, pageSize: 999 } })
        .then((result) => {
          this.coupons = result.data;
        })
        .catch((err) => {
          // this.$Message.error(获取优惠券失败');
          this.$Message.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showProducts(names) {
      // const content = this.$i18n.locale === 'zh' ? `指定餐品: ${names.join(', ')}` : `Selected item: ${names.join(', ')}`;
      // Modal.alert({ content });
      this.$Modal.info({
        content: this.$t('center.coupon.product', { name: names.join(', ') }),
      });
    },
  },
  // watch: {
  //   type(val) {
  //     if (val !== '') {
  //       this.getCoupons();
  //     }
  //   },
  // },
  created() {
    this.$parent.currentModel = 'coupons';
    // this.type = 'unuse';
    this.getCoupons();
  },
};
</script>

<style lang="sass" scoped>
.iview-poptip
  display: block
  text-align: right
  padding-right: 12px
  margin-top: 5px
.user-coupons-wrap
  padding: 0 27px
  .exchange-box
    overflow: hidden
    margin: 20px 0 22px
    .coupont-flag
      height: 28px
      line-height: 28px
      color: #494949
      display: inline-block
    .iview-input
      width: 260px
      outline: 0
      margin: 0 8px 0 10px
      padding: 8px 0 8px 0
      vertical-align: middle
    .cd-button
      margin-left: 10px
  .coupons-box
    margin-top: 24px
  .coupont-types__tab
    height: 38px
    color: #7a7a7a
    width: 696px
    margin: 0 auto
    font-size: 14px
    background-color: #ece6e6
    a
      float: left
      color: #7a7a7a
      display: inline-block
      width: 33.3%
      height: 40px
      line-height: 40px
      text-align: center
      cursor: pointer
      &.actived
        border-bottom: 3px solid #0f9675

  .coupons-error-tips
    width: 227px
    height: 36px
    line-height: 36px
    margin: 160px auto 0
    padding-left: 66px
    // background: url('~static/images/candao-web-v6/user_no_coupon.png') no-repeat left center

  .coupons__ul
    width: 100%
    margin-top: 16px
    display: flex
    flex-wrap: wrap
    justify-content: space-between
    .coupon-item
      // width: 100%
      width: 337px
      height: 114px
      position: relative
      margin-bottom: 1px
      background-color: #f1f1f1
      background: url('../../assets/image/background/discount.png')
      display: flex
      margin-top: 24px
      > div
        display: inline-block
        vertical-align: top
      &-detailed
        text-decoration: underline
        cursor: pointer
        color: #bbb
        font-size: 14px
      &-detailed-content
        .content-explain
          min-height: 50px
      &-name
        font-size: 14px
      .discount-coupon
        margin: 22px 0 0 18px
        color: #fff
        font-size: 25px
        font-weight: 700
      .food-coupon
        display: inline-block
        width: 85px
        height: 66px
        margin: 25px 0 0 18px
        background: url(../../assets/image/icon/icon-food-coupon.png) no-repeat
      .coupon-price, .coupon-goods
        // width: 143px
        text-align: center
      .coupon-price
        color: #fff
        font-size: 25px
        font-weight: 700
        margin: 40px 13px 0 28px
        display: inline-block
      .coupon-goods
        font-size: 15px
        padding: 40px 0px 0 20px
        color: #fff
        font-weight: 700
        white-space: nowrap
      .coupon-txt
        > p
          line-height: 34px
      .coupon-txt
        overflow: auto
        width: 100%
        padding: 5px 0 5px 32px
        .time
          color: #ff8b00
      &:before, &:after
        content: ''
        position: absolute
        top: 0px
        height: 100%
        width: 8px
      &:before
        // background: url('~static/images/candao-web-v6/user_li_bg_l.jpg') repeat-y
        left: 0px
      &:after
        // background: url('~static/images/candao-web-v6/user_li_bg_r.jpg') repeat-y
        right: 0px
</style>
